module.exports = __webpack_public_path__ + "img/media_fed_3.89f7879d.png";